import CommonUser from '../commonUser'
export default class FePhysicalClass {
    /**
     * @type {string}
     * @memberof FePhysicalClass
     * @name 班级主键
     */
    public classId: string;
    /**
     * @type {string}
     * @memberof FePhysicalClass
     * @name 班级编号
     */
    public no: string;
    /**
     * @type {string}
     * @memberof FePhysicalClass
     * @name 班级名称
     */
    public name: string;
    /**
     * @type {string}
     * @memberof FePhysicalClass
     * @name 班级简称
     */
    public shortName: string;
    /**
     * @type {string}
     * @memberof FePhysicalClass
     * @name 排序位
     */
    public orderSeq: string;
    /**
     * @type {string}
     * @memberof FePhysicalClass
     * @name 届ID
     */
    public gradeId: string;
    /**
     * @type {string}
     * @memberof FePhysicalClass
     * @name 届编号
     */
    public gradeNo: string;
    /**
     * @type {string}
     * @memberof FePhysicalClass
     * @name 届名称
     */
    public gradeName: string;
    /**
     * @type {string}
     * @memberof FePhysicalClass
     * @name 届入学时间
     */
    public gradeStartDate: string;
    /**
     * @type {string}
     * @memberof FePhysicalClass
     * @name 班级设立日期（业务时间
     */
    public startDate: string;
    /**
     * @type {string}
     * @memberof FePhysicalClass
     * @name 班级结束日期（业务日期）
     */
    public endDate: string;
    /**
     * @type {string}
     * @memberof FePhysicalClass
     * @name 班级类型ID
     */
    public classCategoryId: string;
    /**
     * @type {string}
     * @memberof FePhysicalClass
     * @name 班级类型名称
     */
    public classCategoryName: string;
    /**
     * @type {string}
     * @memberof FePhysicalClass
     * @name 学部ID
     */
    public zoneId: string;
    /**
     * @type {string}
     * @memberof FePhysicalClass
     * @name 学部编号
     */
    public zoneNo: string;
    /**
     * @type {boolean}
     * @memberof FePhysicalClass
     * @name 有效标识
     */
    public enableFlag: boolean;
    /**
     * @type {string}
     * @memberof FePhysicalClass
     * @name 学部名称
     */
    public zoneName: string;
    /**
     * @type {CommonUser}
     * @memberof FePhysicalClass
     * @name 班主任
     */
    public masters: CommonUser[];
    /**
     * @type {string}
     * @memberof FePhysicalClass
     * @name 学生数量
     */
    public studentNumber: string;
    /**
     * @type {string}
     * @memberof FePhysicalClass
     * @name 租户ID
     */
    public tenantId: string;
    constructor({
        classId = '',
        no = '',
        name = '',
        shortName = '',
        orderSeq = '',
        gradeId = '',
        gradeNo = '',
        gradeName = '',
        gradeStartDate = '',
        startDate = '',
        endDate = '',
        classCategoryId = '',
        classCategoryName = '',
        zoneId = '',
        zoneNo = '',
        zoneName = '',
        enableFlag = true,
        masters = [],
        studentNumber = '',
        tenantId = ''
    } = {}) {
        this.classId = classId
        this.no = no
        this.name = name
        this.shortName = shortName
        this.orderSeq = orderSeq
        this.gradeId = gradeId,
        this.gradeNo = gradeNo,
        this.gradeName = gradeName,
        this.gradeStartDate = gradeStartDate,
        this.startDate = startDate,
        this.endDate = endDate,
        this.classCategoryId = classCategoryId,
        this.classCategoryName = classCategoryName,
        this.zoneId = zoneId,
        this.zoneNo = zoneNo,
        this.zoneName = zoneName,
        this.enableFlag = enableFlag,
        this.masters = masters,
        this.studentNumber = studentNumber,
        this.tenantId = tenantId
    }
}